import { fork, all } from 'redux-saga/effects';
import { watchApiTask } from 'app/sagas';
import { api } from 'app/api';
import * as actions from './reportApplicationActions';

export const getEvaluationTask = watchApiTask(
  actions.GET_EVALUATIONS,
  api.post,
  '/evaluation-system/getEvaluations.php',
);

export const updateEvaluationCriteriaTask = watchApiTask(
  actions.UPDATE_EVALUATION_CRITERIA,
  api.post,
  '/evaluation-system/updateEvaluationCriteria.php',
);

export const getEvaluationCriteriaTask = watchApiTask(
  actions.GET_EVALUATION_CRITERIA,
  api.post,
  '/evaluation-system/getEvaluationCriteria.php',
);

export const getGroupsTask = watchApiTask(
  actions.GET_GROUPS,
  api.post,
  '/evaluation-system/getGroups.php',
);

export const getFilterReportsTask = watchApiTask(
  actions.GET_FILTERS_REPORTS,
  api.post,
  '/evaluation-system/getFilterReports.php',
);

// Root module saga
export function* sagas() {
  yield all([
    fork(updateEvaluationCriteriaTask),
    fork(getEvaluationTask),
    fork(getGroupsTask),
    fork(getFilterReportsTask),
    fork(getEvaluationCriteriaTask),
  ]);
}
